import React, { Component } from "react";

import ExportRecList from "./RecList";
import ExportInvoiceForm from "./Invoice/Form";
import { Modal, ModalBody, ModalHeader } from "reactstrap";


export default class OperationsExportInvoice extends Component{
    constructor(props){
        super(props);
        this.listRef = null;
        this.state = {
            add_export: false
        };
    }

    reloadList = () => {
        if(this.listRef)
            this.listRef.loadList();
    }

    render(){
        return <div>
            <ExportRecList 
                type="invoices" 
                onAddClicked={() => this.setState({add_export: true})}
                ref={ref => {this.listRef = ref;}} 
            />

            <Modal 
                isOpen={this.state.add_export} 
                toggle={() => this.setState({ add_export: false })}
                size="lg"
            >
                <ModalHeader toggle={() => this.setState({ add_export: false })}>Export des factures</ModalHeader>
                <ModalBody>
                    <ExportInvoiceForm 
                        onCreateRec={this.reloadList} 
                        type="classic"
                        headers={{
                            number: "Facture",
                            date: "Date",
                            orders: "Numéro commande",
                            invoice_total_gas_ht: "Montant volume HT",
                            invoice_total_fees_ht: "Frais de services HT",
                            invoice_total_ht: "Total HT",
                            invoice_total_tva: "Total TVA",
                            invoice_total_ttc: "Total TTC",
                            paid: "Est payée"
                        }} 
                    />
                </ModalBody>
            </Modal>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/Operations/Export/Invoice.js